import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dialog-preview.component',
  templateUrl: './dialog-preview.component.html',
  styleUrls: ['./dialog-preview.component.scss']
})
export class DialogPreviewComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit() {

    }

    youtubeLink(link) {
        if (!link.includes('?')) {
            link = link + '?autoplay=1&mute=1';
        }

        if(link.includes("youtube") && link.includes("watch?v=")) {
            link = link.replace('watch?v=', 'embed/');
        }

        return link;
    }

    // The preview's [innerHTML] runs through Angular's sanitizer, which drops every
    // inline style, so CKEditor's alignment is moved onto Bootstrap's matching class
    // first. Spans are skipped: text-align has no effect on an inline element.
    alignedContent(html: string) {
        return String(html ?? '').replace(/<(p|h[1-6]|li|div)\b[^>]*>/gi, tag => {
            const align = /style="[^"]*text-align:\s*(left|center|right|justify)/i.exec(tag)?.[1].toLowerCase();

            if (!align) {
                return tag;
            }

            return /\sclass="/i.test(tag)
                ? tag.replace(/\sclass="/i, ` class="text-${align} `)
                : tag.replace(/^<(\w+)/, `<$1 class="text-${align}"`);
        });
    }
}
